import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as EmailValidator from "email-validator";

import { UsernameCreds } from "../constants/constants";

export const useUsernameLogin = () => {
  const navigate = useNavigate();

  const [state, setState] = useState({
    input: "",
    inputStatus: "",
    inputErrorMessage: "",
    password: "",
    passwordStatus: "",
    passwordErrorMessage: "",
  });

  const handleForms = (field) => (e) => {
    setState({
      ...state,
      [field]: e.target.value,
    });
  };

  const handleLogin = () => {
    // if (!state.input) {
    //   setState({
    //     inputStatus: "error",
    //     inputErrorMessage: "Field is required",
    //   });

    //   return;
    // }

    // if (!state.password) {
    //   setState({
    //     inputStatus: "normal",
    //     inputErrorMessage: "",
    //     passwordStatus: "error",
    //     passwordErrorMessage: "Password is required",
    //   });

    //   return;
    // }

    if (EmailValidator.validate(state.input)) {
      if (state.input !== UsernameCreds.email) {
        setState({
          inputStatus: "error",
          inputErrorMessage: "Username or email address not registered",
          passwordStatus: "normal",
          passwordErrorMessage: "",
        });

        return;
      }
    } else if (state.input !== UsernameCreds.username) {
      setState({
        inputStatus: "error",
        inputErrorMessage: "Username or email address not registered",
        passwordStatus: "normal",
        passwordErrorMessage: "",
      });

      return;
    }

    if (state.password !== UsernameCreds.password) {
      setState({
        inputStatus: "normal",
        inputErrorMessage: "",
        passwordStatus: "error",
        passwordErrorMessage: "Password incorrect, please check and try again"
      })

      return;
    }

    setState({
      ...state,
      passwordStatus: "normal",
      passwordErrorMessage: "",
    });

    navigate("/dashboard");
  };

  return {
    state,
    handleForms,
    handleLogin,
  };
};
